module.exports = __webpack_public_path__ + "img/shape_hearth--black.c104f63.webp";